module.exports = __webpack_public_path__ + "img/LinkedinLogo.1a9291b1.png";